<ng-template #dropdownContentTemplate>
  <div #simpleDropdownContent class="simple-dropdown-content" [style.height]="contentHeight">
    <app-filters-entries-information
      [entriesCount]="objects.length"
      [isMultiSelect]="multiSelect"
      (selectAll)="onSelectAll()"
      (clearAll)="onClearAll()"
      [areAllSelected]="areAllSelected"
    ></app-filters-entries-information>
    <!-- minBufferPx and maxBufferPx added to ensure the virtual scroll covers the whole screen on mobile, the other values shouldn't affect the desktop view -->
    <cdk-virtual-scroll-viewport
      [itemSize]="dropdownItemHeight"
      orientation="vertical"
      [minBufferPx]="mobile ? 900 : 200"
      [maxBufferPx]="mobile ? 1500 : 400">
      <app-dropdown-option
        *cdkVirtualFor="let object of filteredObjects"
        [value]="object"
        [mobile]="mobile"
        [useBorderBottom]="mobile"
        [selected]="objectIsSelected(object)"
        [allowDeselect]="!required || multiSelect"
        (selectionChange)="onObjectSelected(object)">
      <div style="margin-right: 12px; display: flex" *ngIf="filterType === filterTypes.Job_Priority">
        <span
          *ngFor="let item of [].constructor(3); let i = index"
          style="color: #cccccc"
          class="material-symbols-outlined star"
          [class.wetrack-black]="i < object.filterValue"
          >star
        </span>
      </div>
        <div [innerHTML]="object[bindProperty] | safeHtml"></div>
      </app-dropdown-option>
    </cdk-virtual-scroll-viewport>
    <div class="apply-filters-button-container" *ngIf="mobile && multiSelect">
      <app-button-rectangle text="Apply" [fitToContainer]="true" (clicked)="onApply()"></app-button-rectangle>
    </div>
  </div>
</ng-template>

<ng-template #iconsTemplate let-useExpansionIndicator="useExpansionIndicator">
  <div class="simple-dropdown-icons" (click)="onIconsClick($event)">
    <div class="responsive-flex" *ngIf="useExpansionIndicator">
      <div class="simple-dropdown-icons-arrow"></div>
    </div>
  </div>
</ng-template>

<div class="simple-dropdown" [class.disabled]="disabled">
  <ng-template #simpleDropdownInput>
    <div
      class="simple-dropdown-input"
      [class.simple-dropdown-input-close-icon-visible]="searchValue"
      [class.simple-dropdown-input-expanded]="expanded"
    >
      <app-text-field *ngIf="!mobile"
        [class.remove-borders]="removeBorders"
        [showOutlined]="showOutlined"
        [helperText]="helperText"
        [disabled]="disabled"
        [readonly]="readonly"
        [icon]="icon"
        [svg]="svg"
        [placeholder]="label"
        ngDropdown
        [disableMargin]="disableMargin"
        [templateRef]="dropdownContentTemplate"
        (dropdownToggled)="onDropdownToggled($event)"
        [adaptToElementWidth]="true"
        [closeUponSelection]="!multiSelect"
        [(ngModel)]="searchValue"
        (ngModelChange)="onInput()"
        (click)="onClick()"
        (blur)="onBlur()"
      ></app-text-field>

      <app-text-field *ngIf="mobile"
        [disabled]="disabled"
        [placeholder]="label"
        [readonly]="readonly"
        [filterType]="filterType"
        [(ngModel)]="searchValue"
        (ngModelChange)="onInput()"
        (click)="onClick()"
        (blur)="onBlur()"
      ></app-text-field>

      <ng-template [ngTemplateOutlet]="iconsTemplate" [ngTemplateOutletContext]="{ useExpansionIndicator: !mobile }">
      </ng-template>
    </div>
  </ng-template>

  <ng-template [ngTemplateOutlet]="simpleDropdownInput"></ng-template>

  <ion-modal *ngIf="simpleDropdownMobileVisible" [isOpen]="simpleDropdownMobileVisible">
    <ng-template>
      <div class="simple-dropdown-mobile">
        <app-filters-mobile-header
          *ngIf="mobile"
          [title]="'Search'"
          [useClear]="true"
          [clearDisabled]="clearButtonDisabled"
          (cancel)="onCancel()"
          (clear)="onClear($event)"
        ></app-filters-mobile-header>

        <ng-template
          [ngTemplateOutlet]="simpleDropdownInput"
          [ngTemplateOutletContext]="{ isInnerInput: true }"
        ></ng-template>

        <div class="simple-dropdown-mobile-content">
          <ng-template [ngTemplateOutlet]="dropdownContentTemplate"></ng-template>
        </div>
      </div>
    </ng-template>
  </ion-modal>

</div>
